
const initialState = {
    transaction_history: [],
    error: null,
  };
  
  const policyTransactionHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'POLICY_TRANSACTION_HISTORY_SUCCESS':
          return {
          ...state,
          transaction_history: action.payload,
          error: null,
        };
      default:
        return state;
    }
  };
  
  export default policyTransactionHistoryReducer;